import { Component } from '@angular/core';
import { filter, first, fromEvent, map } from 'rxjs';
import { PostMessageFullstoryData, PostMessageInteractionData } from './models/postMessageItem.model';
import { init } from '@fullstory/browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  public done: boolean = false;
  public message: string;
  public title: string;

  constructor() {
    this.listenForInteractionData();
    this.listenForFullstoryData();
  }

  public routeLoaded(): void {
    this.done = true;
  }

  private listenForInteractionData(): void {
    fromEvent<MessageEvent>(window, 'message')
      .pipe(
        filter((message: MessageEvent) => !!message?.data && typeof message?.data === 'string'),
        map((message: MessageEvent) => JSON.parse(message.data)),
        filter((data: PostMessageInteractionData) => data.type === 'interactionsMessage'),
        first()
      )
      .subscribe((data: PostMessageInteractionData) => {
        this.title = data.title;
        this.message = data?.message;
        this.done = false;
      });
  }

  private listenForFullstoryData(): void {
    fromEvent<MessageEvent>(window, 'message')
      .pipe(
        filter(
          (event: MessageEvent) =>
            Array.isArray(event.data) &&
            event.data.every((item: PostMessageFullstoryData) => item && typeof item.key === 'string' && 'value' in item)
        )
      )
      .subscribe((event: MessageEvent) => {
        if (event.data.some((item: PostMessageFullstoryData) => item.key === '_fs_org')) {
          const fsOrgId: string = event.data.find((item: PostMessageFullstoryData) => item.key === '_fs_org')?.value;

          init({ orgId: fsOrgId, recordCrossDomainIFrames: true });
        }
      });
  }
}
